import Button from 'src/components/primitives/Button/Button';
import Link from 'src/components/primitives/Link/Link';
import { DRIFT_DISCORD_URL } from 'src/constants/constants';
import { cj } from 'src/utils/classNames';

const PREVIEW_LINK_SUFFIX = 'drift-web.vercel.app';

export default function ErrorPage({ error }: { error?: any }) {
	const domain = window.location.hostname;
	const isPreviewLink = domain.includes(PREVIEW_LINK_SUFFIX);

	return (
		<>
			<div className="relative grid h-full place-items-center bg-main-bg px-lg">
				<div className="z-1 flex flex-col items-center gap-y-md text-center">
					<h1 className="z-1 text-[48px] font-bold text-purple-link sm:text-[90px]">
						Whoops!
					</h1>

					<div className="z-1 flex w-[min(100%,448px)] flex-col items-center gap-y-2xl text-center text-text-default">
						<p className="typo-h4 sm:typo-h3">
							You&apos;ve drifted a bit too far
						</p>
						<p className="typo-b3">
							Something&apos;s gone wrong with the action you&apos;ve performed.
							Go back to the Homepage and try again. If this problem persists,
							please reach out on{' '}
							<Link href={DRIFT_DISCORD_URL} openInNewTab>
								Discord
							</Link>
							.
						</p>
						<Button as="a" href="/" size="lg">
							Go to Homepage
						</Button>
					</div>
				</div>

				{/** Grid / gradient overlay. */}
				<div
					className={cj(
						'absolute top-[38%] left-1/2 -translate-x-1/2 -translate-y-1/2 sm:top-[51%] sm:-translate-y-3/4',
						'h-[260px] w-[min(90%,1040px)] error-page-spotlight-mask sm:h-[360px]'
					)}
				>
					<div
						className={cj(
							'relative size-full overflow-hidden rounded-[720px]',
							'bg-[radial-gradient(60%_90%_at_50%_50%,rgba(116,42,129,0.32)_0%,rgba(116,42,129,0.18)_35%,rgba(116,42,129,0.06)_70%,var(--main-bg)_100%)]',
							'sm:bg-[radial-gradient(32%_60%_at_50%_50%,rgba(116,42,129,0.32)_0%,rgba(116,42,129,0.18)_40%,rgba(116,42,129,0.06)_72%,var(--main-bg)_100%)]'
						)}
					>
						<div className="error-page-grid-overlay" />
						<div className="error-page-noise-overlay absolute inset-0" />
					</div>
				</div>
			</div>

			{/** Used to debug on mobile phones where access to console is not available */}
			{isPreviewLink && !!error && (
				<div className="typo-b4 text-text-default">
					<details>
						<summary>Error details</summary>
						{JSON.stringify(error)}
					</details>
				</div>
			)}
		</>
	);
}
